import React from 'react';
import classNames from 'classnames';
import styles from './page-header-color-sample.module.scss';

type Props = {
  hexColor: string | undefined;
  className?: string;
};

export const PageHeaderColorSample: React.FC<Props> = ({ hexColor, className }) => {
  return (
    <div
      className={classNames(styles.root, className)}
      style={{
        '--igp-color-sample-color': hexColor ?? '#fff',
      }}
    />
  );
};
